import {createAction} from '@reduxjs/toolkit'

import {SelectedAgreement} from './interfaces'

/** 개인정보 전체 동의 action */
export const enableAllAgreement = createAction<{
    enabled: boolean
    selected: SelectedAgreement
}>('agreement/enableAllAgreement')

/** 오픈뱅킹 동의 action */
export const agreeToOpenBanking = createAction<boolean>('agreement/agreeToOpenBanking')

/** 패밀리 결제 법정 동의 action */
export const agreeToFamilyPayMinorAgreed = createAction<boolean>('agreement/agreeToFamilyPayMinorAgreed')

/** 패밀리 결제 최초 1회 동의 action */
export const agreeToFamilyPayAgreed = createAction<boolean>('agreement/agreeToFamilyPayAgreed')

/** 쇼핑몰 구매 약관 동의 action */
export const agreeToMallContractAgreed = createAction<boolean>('agreement/agreeToMallContractAgreed')

/** 구매정보 제3자 제공(전통주 일때(성인인증 필요) 동의 action */
export const agreeToThirdPeopleAgreed = createAction<boolean>('agreement/agreeToThirdPeopleAgreed')

/** 개인정보 국외이전 동의 action */
export const agreeToIiomaAgreed = createAction<boolean>('agreement/agreeToIiomaAgreed')

/** 맞춤제작상품 구매,교환,반품,환불 제한  동의 action */
export const agreeToCustomOrderAgreed = createAction<boolean>('agreement/agreeToCustomOrderAgreed')

/** 예약구매 상품 구매 및 취소 동의 action */
export const agreeToPreOrderAgreed = createAction<boolean>('agreement/agreeToPreOrderAgreed')

/** 예약/주문 자동결제 이용안내 동의 action */
export const agreeToBookingAgreed = createAction<boolean>('agreement/agreeToBookingAgreed')

/** 정기구독 동의 action */
export const agreeToShoppingSubscriptionAgreed = createAction<boolean>('agreement/agreeToShoppingSubscriptionAgreed')

/** 기존 결제수단 변경 동의 action */
export const agreeToReplaceExistingPaymentMethod = createAction<boolean>(
    'agreement/agreeToReplaceExistingPaymentMethod',
)
